<template>
  <div>
    <Header :logged="logged" />
      <b-container>
        <b-row>
          <b-col>
            <div class="mt-5">
              <b-img :src="require('@/assets/imgs/banner_topo_foto.png')" fluid></b-img>
            </div>
          </b-col>
        </b-row>
        <b-row>
          <b-col class="col-md-12 col-sm-12">
            <p class="mt-4 text-left letraRobReg">
                Os cartórios de protesto foram destaque numa série de reportagens em diversos veículos de imprensa, 
                que destacaram o uso do instrumento do protesto para a recuperação de dívidas rurais, públicas, multas de autarquias e trânsito, 
                descumprimento de decisões judiciais, entre outros. Confira abaixo.
            </p>
          </b-col>
        </b-row>
        <b-row>
          <b-col class="col-md-12">
            <p class="mt-5 text-left text-primary letratbb">QUEM CONHECE, USA</p>
          </b-col>
        </b-row>

        <!-- TV GLOBO -->
        <b-row>
          <b-col class="col-md-4 col-sm-12">
            <div>
              <b-img :src="require('@/assets/imgs/TV GLOBO.png')" fluid></b-img>
            </div>
          </b-col>
          <b-col class="col-md-8">
             <b-row>
              <b-col class="col-md-12">
                <p class="text-left letraRobBoldTit mt-2 "><b>TV GLOBO</b></p>
              </b-col>
            </b-row>
            <b-row>
              <b-col class="col-md-12 letraRobReg">
                Reportagem da TV Globo, no programa Globo Rural, mostra como é possível utilizar os cartórios de protesto para recuperação de dívidas 
                rurais.
              </b-col>
            </b-row>
            <b-row>
              <b-col class="col-md-12 letraRobReg mt-4">
                <a href="https://globoplay.globo.com/v/7265476/programa/" target="_BLANK" class="letraLink">Veja a matéria completa clicando aqui</a>
              </b-col>
            </b-row>
          </b-col>
        </b-row>

        <b-row>
          <b-col class="col-md-12 text-left">
            <hr/>
          </b-col>
        </b-row>

        <!-- REVISTA EXAME -->
        <b-row>
          <b-col class="col-md-4 col-sm-12 text-left">
            <div>
              <b-img :src="require('@/assets/imgs/EXAME-MIDIA.png')" fluid></b-img>
            </div>
          </b-col>
          <b-col class="col-md-8 text-left">
             <b-row>
              <b-col  class="col-md-12">
                <p class="text-left letraRobBoldTit mt-2"><b>REVISTA EXAME</b></p>
              </b-col>
            </b-row>
            <b-row>
              <b-col  class="col-md-12 text-left letraRobReg">
                Revista Exame destaca que os cartórios de protesto são a maneira mais rápida de recuperar créditos.
              </b-col>
            </b-row>
            <b-row>
              <b-col  class="col-md-12 text-left letraRobReg mt-4">
                <a href="https://exame.abril.com.br/negocios/cartorios-de-protesto-sao-a-maneira-mais-rapida-de-cobrar-dividas/" target="_BLANK" class="letraLink">Veja a matéria completa clicando aqui</a>
              </b-col>
            </b-row>
          </b-col>
        </b-row>

        <b-row>
          <b-col  class="col-md-12 text-left">
            <hr/>
          </b-col>
        </b-row>

        <!-- JORNAL VALOR ECONÔMICO -->
        <b-row>
          <b-col class="col-md-4 col-sm-12 text-left">
            <div>
              <b-img :src="require('@/assets/imgs/VALOR.png')" fluid></b-img>
            </div>
          </b-col>
          <b-col class="col-md-8">
             <b-row>
              <b-col  class="col-md-12 text-left">
                <p class="text-left letraRobBoldTit mt-2"><b>JORNAL VALOR ECONÔMICO</b></p>
              </b-col>
            </b-row>
            <b-row>
              <b-col  class="col-md-12 text-left letraRobReg">
                Reportagem do jornal Valor Econômico destaca que protesto é grande parceiro na recuperação de créditos fiscais.
              </b-col>
            </b-row>
            <b-row>
              <b-col  class="col-md-12 text-left letraRobReg mt-4">
                <a href="https://www.valor.com.br/legislacao/5156314/protesto-de-divida-eleva-arrecadacao" target="_BLANK" class="letraLink">Veja a matéria completa clicando aqui</a>
              </b-col>
            </b-row>
          </b-col>
        </b-row>

        <b-row>
          <b-col  class="col-md-12 text-left">
            <hr/>
          </b-col>
        </b-row>

        <!-- O ESTADÃO DE SÃO PAULO -->
        <b-row>
          <b-col class="col-md-4 col-sm-12 text-left">
            <div>
              <b-img :src="require('@/assets/imgs/ESTADAO.png')" fluid></b-img>
            </div>
          </b-col>
          <b-col class="col-md-8">
             <b-row>
              <b-col  class="col-md-12 text-left">
                <p class="text-left letraRobBoldTit mt-2"><b>O ESTADÃO DE SÃO PAULO</b></p>
              </b-col>
            </b-row>
            <b-row>
              <b-col  class="col-md-12 text-left letraRobReg">
                Coluna de Sonia Racy, no jornal O Estado de São Paulo, registra aumento de recuperação de crédito pelo Poder Público.
              </b-col>
            </b-row>
            <b-row>
              <b-col  class="col-md-12 text-left letraRobReg mt-4">
                <a href="https://cultura.estadao.com.br/blogs/direto-da-fonte/creditos-recuperados-pelo-poder-publico-crescem-285-no-trimestre/" target="_BLANk" class="letraLink">Veja a matéria completa clicando aqui</a>
              </b-col>
            </b-row>
          </b-col>
        </b-row>

        <b-row>
          <b-col  class="col-md-12 text-left">
            <hr/>
          </b-col>
        </b-row>

        <!-- DCI.COM.BR -->
        <b-row>
          <b-col class="col-md-4 col-sm-12 text-left">
            <div>
              <b-img :src="require('@/assets/imgs/DCI.png')" fluid></b-img>
            </div>
          </b-col>
          <b-col class="col-md-8">
             <b-row>
              <b-col  class="col-md-12 text-left">
                <p class="text-left letraRobBoldTit mt-2"><b>DCI.COM.BR</b></p>
              </b-col>
            </b-row>
            <b-row>
              <b-col  class="col-md-12 text-left letraRobReg">
                Artigo do vice-presidente do IEPTB-BR, Claudio Marçal, fala da importância da 
                criação da Central Nacional de Serviços Eletrônicos Compartilhados dos Tabeliães 
                de Protesto(Cenprot), que presta informações gratuitas sobre protesto e é responsável pela escrituração das duplicatas, pela 
                distribuição nacional dos títulos.
              </b-col>
            </b-row>
            <b-row>
              <b-col  class="col-md-12 text-left letraRobReg mt-4">
                <a href="https://soundcloud.com/brmaismoderno/cbn-poder-publico-arrecada-r-157-milhoes" target="_BLANK" class="letraLink">Veja a matéria completa clicando aqui</a>
              </b-col>
            </b-row>
          </b-col>
        </b-row>

        <b-row>
          <b-col  class="col-md-12 text-left">
            <hr/>
          </b-col>
        </b-row>

        <!-- Reportagem -->
        <b-row>
          <b-col class="col-md-4 col-sm-12 text-left">
            <div>
              <b-img :src="require('@/assets/imgs/prnoar.png')" fluid></b-img>
            </div>
          </b-col>
          <b-col class="col-md-8">
             <b-row>
              <b-col  class="col-md-12 text-left">
                <p class="text-left letraRobBoldTit mt-2"><b>PARANÁ NO AR</b></p>
              </b-col>
            </b-row>
            <b-row>
              <b-col  class="col-md-12 text-left letraRobReg">
                Reportagem da Paraná no Ar, mostra como a plataforma digital, tem ajudado empresas a cobrar os devedores e solucionar dívidas de qualquer valor. Confira!
              </b-col>
            </b-row>
            <b-row>
              <b-col  class="col-md-12 text-left letraRobReg mt-4">
                <a href="https://www.youtube.com/watch?v=R1ZM6C7L0pM" target="_BLANK" class="letraLink">Veja a matéria completa clicando aqui</a>
              </b-col>
            </b-row>
          </b-col>
        </b-row>

        <b-row>
          <b-col class="col-md-12 text-center mt-5">
             <b-row>
                <b-col class="col-md-4 col-sm-6">
                  <a  href="https://pt-br.facebook.com/cartoriosdeprotestobr/" target="_BLANK">                         
                  <b-img :src="require('@/assets/imgs/facebook.png')" fluid></b-img></a>
                </b-col>
                <b-col class="col-md-4 col-sm-6">
                  <a  href="https://pt.linkedin.com/company/ieptb-br?trk=organization-update_share-update_actor-text" target="_BLANK">    
                  <b-img :src="require('@/assets/imgs/linkedin.png')" fluid></b-img></a>
                </b-col>
                <b-col class="col-md-4 d-sm-none d-md-block">
                  <a  href="https://pt.wikipedia.org/wiki/Cart%C3%B3rios_de_Protesto" target="_BLANK">
                  <b-img :src="require('@/assets/imgs/Wikipedia.png')" fluid></b-img></a>
                </b-col>
                <b-col class="col-md-12 d-none d-sm-block d-md-none">
                     <a  href="https://pt.wikipedia.org/wiki/Cart%C3%B3rios_de_Protesto" target="_BLANK">
                  <b-img :src="require('@/assets/imgs/Wikipedia.png')" fluid></b-img></a>
                </b-col>
             </b-row>
          </b-col>
        </b-row>
         <b-row class="mt-4 rodape">
           <b-alert show>
            <p class="text-center">
              O IEPTB - Instituto de Estudos de Protesto de Títulos do Brasil - é a entidade de classe representante dos Cartórios de Protestos do Brasil 
              que tem por finalidade efetuar pesquisas, estudos e desenvolver aprimoramentos para a atividade do protesto, com o intuito de melhor atender o público usuário. <br><!-- Fale conosco através do 0800 878 2704 ou nos --><br> Envie um e-mail consultaprotesto@cartoriosdeprotesto.org.br
            </p>
           
            <p class="text-center rodapeP">
              Todos os direitos reservados © 2018<br>
              Instituto de Estudos de Protesto de Títulos do Brasil
            </p>
           </b-alert>
         </b-row>
      </b-container>
    </div>
</template>

<script>
import Header from '../components/Header'

export default {
    components: {
    Header
  },
   methods: {},
   data() {
     return {
      alfabeto: [],
      letra: false,
      alfabeto_nao: [],
      letra_nao: false,
      estados: {},
      uf_selecionada: {},
      cartorios: {},
      exibir_cartorios: false,
      logged: false,
      loading_cartorios: false
     }
   }
}
</script>

<style scoped>

.letraRobReg{
  font-size: 20px;
  color:#333333;
  font-family: "Kanit", sans-serif !important;
}
.letratbb{
  font-size: 34px;
  color:#535ba5;
  font-family: "Kanit", sans-serif !important;
}
.letraRobBoldTit{
  font-size: 24px;
  color:#333333;
  font-family: "Kanit", sans-serif !important;
}
.letraLink{
  font-size: 20px;
  color:#535ba5;
  font-family: "Kanit", sans-serif !important;

}
hr{
  color: #eaecf5;
}
.rodape{
  font-size: 14px;
}

.rodapeP{
  margin-bottom: -0.5rem !important;
}
</style>
